/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TailoredDefragSummaryAttendees_personList = {
    readonly list: ReadonlyArray<{
        readonly primaryEmail: string;
        readonly profile: {
            readonly givenName: string | null;
            readonly familyName: string | null;
        } | null;
    }>;
    readonly " $fragmentRefs": FragmentRefs<"AvatarRow_personList">;
    readonly " $refType": "TailoredDefragSummaryAttendees_personList";
};
export type TailoredDefragSummaryAttendees_personList$data = TailoredDefragSummaryAttendees_personList;
export type TailoredDefragSummaryAttendees_personList$key = {
    readonly " $data"?: TailoredDefragSummaryAttendees_personList$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TailoredDefragSummaryAttendees_personList">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TailoredDefragSummaryAttendees_personList",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "Person",
            "kind": "LinkedField",
            "name": "list",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "primaryEmail",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserProfile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "givenName",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "familyName",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AvatarRow_personList"
        }
    ],
    "type": "PersonList",
    "abstractKey": null
} as any;
(node as any).hash = '85a192446fa02f5c812c7f7d8daf4784';
export default node;
